export function begin_date(state){
    return state.begin_date
}

export function end_date(state){
    return state.end_date
}